// Render-only label styling. Database Python stays editable and contains no PNG.
// Keep the normalization block aligned with backend word/figure_labels.py.
export const withHandoutFigureLabels = (code, widthCm, bodyFontSize = 12) => {
  const width = Number(widthCm), body = Number(bodyFontSize || 12);
  if (!String(code || "").trim() || !Number.isFinite(width) || !Number.isFinite(body) || width < .2 || width > 30 || body < 6 || body > 36) return code;
  return `${String(code).trimEnd()}

# handout: labels at 70% of body text v2 (render only)
import matplotlib.pyplot as _handout_plt
from matplotlib.text import Text as _HandoutLabel
_handout_fig = _handout_plt.gcf()
_handout_fig.set_dpi(170)
_handout_labels = [label for label in _handout_fig.findobj(match=_HandoutLabel)
                   if label.get_visible() and label.get_text().strip()]
_handout_target_pt = ${body} * 0.7
_handout_width_in = ${width} / 2.54
_handout_pad = _handout_plt.rcParams.get("savefig.pad_inches", 0.1)
if not isinstance(_handout_pad, (int, float)):
    _handout_pad = 0.1
for _handout_step in range(12):
    _handout_fig.canvas.draw()
    _handout_bounds = _handout_fig.get_tightbbox(_handout_fig.canvas.get_renderer())
    _handout_inches = max(0.1, _handout_bounds.width + 2 * _handout_pad)
    _handout_size = _handout_target_pt * _handout_inches / _handout_width_in
    _handout_error = max([abs(label.get_fontsize() - _handout_size) for label in _handout_labels] or [0])
    for _handout_label in _handout_labels:
        _handout_label.set_fontsize(_handout_size)
    if _handout_error < 0.005:
        break
`;
};

export const handoutLabelAsset = (asset, widthCm, bodyFontSize = 12) => {
  if (asset?.source_language !== "python" || !String(asset?.source_code || "").trim()) return asset;
  const code = withHandoutFigureLabels(asset.source_code, widthCm, bodyFontSize);
  if (code === asset.source_code) return asset;
  const styled = { ...asset, source_code: code, url: "", storage_key: "" };
  for (const key of ["_preview_url", "_previewUrl", "_preview_source_code", "preview_status", "preview_message", "_previewStatus", "_previewMessage", "width_px", "height_px"]) delete styled[key];
  return styled;
};
